module.exports = __webpack_public_path__ + "img/42.9202f28a.jpg";